'use client';

import { createContext, ReactNode, useContext, useRef } from 'react';
import useAboveFold from '@/libraries/hooks/use-above-fold';

const AboveFoldContext = createContext<boolean | undefined>(undefined);

export const AboveFoldProvider = ({
  value,
  children,
}: {
  children: ReactNode;
  value: boolean;
}) => {
  return (
    <AboveFoldContext.Provider value={value}>
      {children}
    </AboveFoldContext.Provider>
  );
};

export const useAboveFoldContext = () => {
  const context = useContext(AboveFoldContext);

  return context ?? false;
};

export const ModuleAboveFold = ({ children }: { children: ReactNode }) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const isAbove = useAboveFold(ref);

  return (
    <div ref={ref}>
      <AboveFoldProvider value={isAbove}>{children}</AboveFoldProvider>
    </div>
  );
};

export default AboveFoldContext;
